export default __webpack_public_path__ + "static/media/90_mobile.dde9ef3b.jpg";